// test1389
(1389 && 0);
